"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReapAbilityHandler = exports.ReapActorAbilityFactory = exports.ReapAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const IdArray_1 = require("../../core/utils/IdArray");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ReapAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Reap;
        this.__typeName = "Reap";
    }
}
exports.ReapAbilityArgs = ReapAbilityArgs;
let ReapActorAbilityFactory = class ReapActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Reap", "AllEnemies", 0);
    }
};
ReapActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Reap")
], ReapActorAbilityFactory);
exports.ReapActorAbilityFactory = ReapActorAbilityFactory;
let ReapAbilityHandler = class ReapAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const randomEnemyOrder = (0, IdArray_1.shuffle)(container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies));
        container.applyJumpingProjectileAttackWithDamage({
            sequence,
            attackerId: ability.invokerId,
            targetIds: randomEnemyOrder,
            attackType: "ranged",
            abilityKey: ability.args.__typeName,
            projectileType: "GreenOrb",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 80)
            ],
            onHit: (sequence, _attack, _damages, targetId) => {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(targetId, "chest"), "FaintYellowGreenCircleDispersion"));
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId,
                    effect: new __1.PoisonedEffectArgs("Power", 10),
                    duration: Duration_1.Duration.Turns(3),
                    sequence: sequence.pushSequence("sequential"),
                    onApplied(sequence) {
                        sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(targetId, "chest"), "FaintYellowGreenCircleDispersion"));
                    }
                });
            },
        });
    }
};
ReapAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Reap)
], ReapAbilityHandler);
exports.ReapAbilityHandler = ReapAbilityHandler;
